import React from 'react';
import { useUpdateTravellers } from '../../../../../../../ConfirmOption/hooks';
import PassengersToolbarWithoutForm from '../PassengersToolbarWithoutForm/PassengersToolbarWithoutForm';
const PassengersToolbarWithForm = props => {
    const { setNextStep } = props;
    const updateTravellers = useUpdateTravellers({ setNextStep });
    return React.createElement(PassengersToolbarWithoutForm, Object.assign({ updateTravellers: updateTravellers }, props));
};
export default PassengersToolbarWithForm;
